export const getUTMs = locationSearch => {
  const utms = {
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
    utm_content: '',
    utm_term: '',
  };

  if (locationSearch) {
    Object.keys(utms).forEach(key => {
      if (locationSearch?.has(key)) {
        utms[key] = locationSearch?.get(key);
      }
    });
  }

  return utms;
};

export const getUrlWithUTMs = ({ url, utms }) => {
  if (!url) {
    return '';
  }

  const hasQueryParams = url?.includes('?') || url?.includes('&');
  const isAppLink = url?.includes('app.wooclap.com');

  let queryString = utms
    ? Object.entries(utms)
        .filter(([key, value]) => value !== undefined && value !== '')
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join('&')
    : '';

  if (isAppLink) {
    const isBrowser = () => typeof window !== 'undefined';

    queryString += isBrowser()
      ? `${queryString ? '&' : ''}origin=${window.location.pathname}`
      : '';
  }

  const glIndex = url.indexOf('_gl=');
  if (glIndex !== -1) {
    const beforeGl = url.substring(0, glIndex);
    const afterGl = url.substring(url.indexOf('&', glIndex));
    url = beforeGl + afterGl;
  }

  return `${url}${
    queryString ? (hasQueryParams ? '&' : '?') : ''
  }${queryString}`;
};
